// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"89a5d5e4","453":"dd503337"}[chunkId] + ".chunk.js";
};